<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="login-title">数据管理平台</h2>
      <el-form ref="form" :model="form" :rules="rules" label-width="0">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
                    @keyup.enter.native="handleLogin"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width:100%" @click="handleLogin">登 录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'Login',
  data() {
    return {
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.loading = true
        api.login(this.form).then(res => {
          this.$store.commit('SET_TOKEN', res.data.token)
          this.$store.commit('SET_USER_INFO', {
            userId: res.data.userId,
            username: res.data.username,
            nickname: res.data.nickname,
            roleType: res.data.roleType,
            canImport: res.data.canImport,
            incomePermission: res.data.incomePermission || 'BOTH',
            boundVideoIds: res.data.boundVideoIds || []
          })
          this.$router.push('/dashboard')
        }).catch(() => {}).finally(() => { this.loading = false })
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.login-card {
  width: 400px;
  padding: 20px;
}
.login-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}
.login-notice {
  text-align: center;
  background: #f56c6c;
  color: #fff;
  font-size: 14px;
  padding: 10px 24px;
  border-radius: 4px;
  margin-bottom: 16px;
  white-space: nowrap;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
